// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"165":"86ed29e9","246":"72b3bf7c","249":"86ed29e9","816":"86ed29e9","916":"f854fd95"}[chunkId] + ".chunk.css";
};